import { render } from "./RoomView.vue?vue&type=template&id=5259ea8d"
import script from "./RoomView.vue?vue&type=script&lang=js"
export * from "./RoomView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__